"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_hook_form_1 = require("react-hook-form");
const core_1 = require("@material-ui/core");
const FormTextField = ({ error, errorClassName, label, name, props, rules, }) => {
    const { control } = react_hook_form_1.useFormContext();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_hook_form_1.Controller, { as: react_1.default.createElement(core_1.TextField, Object.assign({ error: !!error, label: label, variant: "outlined" }, props)), defaultValue: "", control: control, name: name, rules: rules }),
        react_1.default.createElement("div", null, error && react_1.default.createElement("span", { className: errorClassName }, error.message))));
};
exports.default = FormTextField;
